/* tslint:disable */
/* eslint-disable */
/**
 * LogQS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Log } from "./Log";
import { LogFromJSON, LogFromJSONTyped, LogToJSON } from "./Log";

export interface LogListResponse {
  offset: number;
  limit: number;
  order: string;
  sort: string;
  count: number;
  data: Array<Log>;
}

export function LogListResponseFromJSON(json: any): LogListResponse {
  return LogListResponseFromJSONTyped(json);
}

export function LogListResponseFromJSONTyped(json: any): LogListResponse {
  if (json == null) {
    return json;
  }

  return {
    offset: json["offset"],
    limit: json["limit"],
    order: json["order"],
    sort: json["sort"],
    count: json["count"],
    data: (json["data"] as Array<any>).map(LogFromJSON),
  };
}

export function LogListResponseToJSON(
  value: LogListResponse | null | undefined,
): any {
  if (value == null) {
    return value;
  }

  return {
    offset: value.offset,
    limit: value.limit,
    order: value.order,
    sort: value.sort,
    count: value.count,
    data: (value.data as Array<any>).map(LogToJSON),
  };
}
